import { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SquareCheck, Trash } from "lucide-react";

import { DynamicTable } from "@components/table-custom/table";

import { RecusarTarefaModal } from "@pages/admin/remessas/components/recusar-tarefa-modal";
import { SearchPegarTarefas } from "@pages/admin/remessas/components/search-pegar-tarefas";
import { PegarTarefaModal } from "@pages/producao/components/pegar-tarefa-modal";

import { usePegarTarefasAdmin } from "@/hooks/admin/pegar-tarefas";

// hooks / zustand - admin
import { useStoreZustandPegarTarefas } from "@/store-zustand/admin/pegar-tarefas";

type IOrders = {
  dadosPegarTarefas: any[];
  total_remessas_solicitadas: number;
  setCurrentScreen: () => void;
};

export function PegarTarefasTable({
  dadosPegarTarefas,
  total_remessas_solicitadas,
  setCurrentScreen: _setCurrentScreen,
}: IOrders) {
  const router = useNavigate();

  const [isModalRecusarTarefa, setIsModalRecusarTarefa] = useState(false);

  const { paginations, isLoading } = usePegarTarefasAdmin();

  const {
    currentPage,
    setCurrentPage,
    totalItemsPage,
    itemsPerPage,
    lastPage,
    isModalPegarTarefas,
    setIsModalPegarTarefas,
    idRemessa,
    setIdRemessa,
    setTarefa,
  } = useStoreZustandPegarTarefas();

  const onGoToPage = useCallback(
    (action: number | "prev" | "next") => {
      const newPage =
        action === "prev"
          ? Math.max(1, currentPage - 1)
          : action === "next"
            ? Math.min(lastPage, currentPage + 1)
            : action;

      setCurrentPage(newPage);
    },
    [currentPage, lastPage, setCurrentPage]
  );

  return (
    <div className="flex h-full min-h-0 w-full min-w-0 flex-col">
      <DynamicTable
        fillViewport
        title="Pegar Tarefas"
        description="Gerencie suas tarefas e visualize quando quiser."
        subDescripion={`Total de ${total_remessas_solicitadas} resultados`}
        isLoadingPage={isLoading}
        data={dadosPegarTarefas || []}
        offset={1}
        totalItems={totalItemsPage}
        itemsPerPage={itemsPerPage}
        columns={[
          { label: "Remessa", accessor: "numero_remessa" },
          { label: "Cliente", accessor: "nome_identificacao", limit: 60 },
          {
            label: "Modelo",
            accessor: "modelo",
            limit: 60,
            customRender: (value: any, item: any) => (
              <Link
                to={`/visualizar-modelo`}
                className="font-medium text-blue-600 transition-colors duration-200 hover:text-blue-800 hover:underline"
                onClick={() => setTarefa(item)}
              >
                {value}
              </Link>
            ),
          },
          { label: "Qtd", accessor: "quantidadeSolicitacao" },
          { label: "Tecnologia", accessor: "tecnologia" },
          {
            label: "Posição",
            accessor: "posicao",
          },
          {
            label: "Prazo",
            accessor: "prazo",
            isBadge: true,
            badgeClassName: "bg-green-500",
          },
          {
            label: "Status",
            accessor: "status",
            isBadge: true,
            badgeClassName: "bg-green-500",
          },
          { label: "Solicitante", accessor: "solicitante", limit: 60 },
          { label: "Designer", accessor: "designer", limit: 60 },
          { label: "Data Solicitação", accessor: "data" },
        ]}
        onGoToPage={onGoToPage}
        currentPage={currentPage}
        paginations={paginations}
        lastPage={lastPage}
        actions={[
          {
            icon: SquareCheck,
            label: "Pegar tarefa",
            textColor: "text-green-600",
            onClick: (item: any) => {
              setIdRemessa(item?.remessa);
              setTarefa(item);
              setIsModalPegarTarefas(true);
            },
          },
          {
            icon: Trash,
            label: "Excluir",
            textColor: "text-red-600",
            onClick: (item: any) => {
              setIdRemessa(item?.remessa);
              setTarefa(item);
              setIsModalRecusarTarefa(!isModalRecusarTarefa);
            },
          },
        ]}
        childerSearch={<SearchPegarTarefas />}
      />

      {isModalPegarTarefas && idRemessa && (
        <PegarTarefaModal
          idRemessa={idRemessa}
          handleToggleCreateActvityModal={() => {
            setIsModalPegarTarefas(!isModalPegarTarefas);
          }}
        />
      )}

      {isModalRecusarTarefa && (
        <RecusarTarefaModal
          idRemessa={idRemessa}
          handleToggleCreateActvityModal={() => {
            setIsModalRecusarTarefa(!isModalRecusarTarefa);
          }}
          setCurrentScreen={() => {
            router("/search-shipment");
          }}
        />
      )}
    </div>
  );
}
